
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import useAppState from '../../context/AppContext';
import * as Yup from 'yup';
import { ChangeEvent, useState } from 'react';
import LoaderModal from '../../modals/common/LoaderModal';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import { IApiErrors,  } from '../../context/model';
import { isAcceptedFileSizeMultiple, isValidFileSize, isValidFileType } from '../../utils/utils';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { AxiosError } from 'axios';
import MgpInputFileUpload from '../../elements/MgpInputFileUpload/MgpInputFileUpload';
import ListOfFileUploaded from './ListOfFileUploaded';
import { ERROR_MESSAGES, PROPOSITION_DOC_TYPES } from '../../const/AppConst';
import Modal from 'react-modal';
import { compressFile } from '../../services/CustomerApiService';


type UploadTwoSidedDesktopComponentProps = {
    isOpen: boolean,
    onCloseModal: () => void,
    onUploadAction: (fileToUpload: File, backSideFile: File) => void,
    docType: string,
    accessToken?: string,
    handleSwitchUploadFromPhone?: () => void,
    uploadError?: string
}

type AddStep0FormData = {
}

export default function UploadTwoSidedDesktopComponent({isOpen, onCloseModal, onUploadAction, docType, accessToken, handleSwitchUploadFromPhone, uploadError}: Readonly<UploadTwoSidedDesktopComponentProps>) {
  Modal.setAppElement("#root");

  const {state: { jwtToken }} = useAppState();

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [file, setFile] = useState<File | null>(null);
  const [openPreviewFile, setOpenPreviewFile] = useState<boolean>(false);
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false);
  const [rectoFile, setRectoFile ] = useState<File | null>(null);
  const [versoFile, setVersoFile ] = useState<File | null>(null);
  const [type, setType ] = useState<'RECTO' | 'VERSO'>('RECTO');


  const validationSchema = Yup.object().shape({
  });

  const {
    register,
    formState: { errors },
  } = useForm<AddStep0FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {

    },
    resolver: yupResolver(validationSchema),
  });


  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>, docType: 'RECTO' | 'VERSO' ) => {
    try {
        const uploadedfile = event.target.files && event.target.files[0];
        if (uploadedfile) {
            if(!isValidFileType(uploadedfile)) {
                setErrorFileTypeMsg(true);
            } else if (!isValidFileSize(uploadedfile)) {
                setErrorFileSizeMsg(true);
            } else if(!isAcceptedFileSizeMultiple(uploadedfile)) {
              try {
                const token = accessToken ?? jwtToken!.accessToken;

                const res = await compressFile(token, uploadedfile);
                const content = res.data as Blob;
                const filename= type;
                const newFile = new File([content], filename, {type: uploadedfile.type});
                setOpenPreviewFile(true);
                setShowUploadButton(true);
                setFile(newFile);
                setType(docType);
              } catch(e) {
                setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
              } 
                
            } else {
                setOpenPreviewFile(true);
                setShowUploadButton(true);
                setFile(uploadedfile);
                setType(docType);
            }
        } else {
            setErrorMsg('Il y a une erreur sur votre téléchargement. Merci de réessayer');
        } 
    }  catch (error) {
        const err = error as AxiosError;
        if(err.response && err.response.status === 400) {
          const errorData = err.response?.data as IApiErrors;
          setErrorMsg("Erreur: " + errorData.message);
        } else {
          setErrorMsg("Une erreur technique est survenue ");
        }
    }
  };

  const onConfirmAction = () => { 
    setOpenPreviewFile(false);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    if (file) { 
        if (type === "RECTO") {
            setRectoFile(file);
        } else {
            setVersoFile(file);
        }
        setFile(null);
    }
  }

  const handleClosePreviewModal = () => {
    setOpenPreviewFile(false);
    setFile(null);
  }

  const onConfirmUploadAction = async (e: any) => {
    e.preventDefault();
    setErrorMsg(null);
    setErrorFileTypeMsg(false);
    setLoading(true);
    try {
        if (rectoFile && versoFile) {
            onUploadAction(rectoFile, versoFile);
            setLoading(false);
          } else {
            setErrorMsg("Une erreur technique est survenue. Veuillez recommencer un nouveau téléchargement.");
            setLoading(false);
          }
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onDownLoadDocument = async (file: File) => {
      setFile(file);
      setOpenPreviewFile(true);
      setShowUploadButton(false);
  }

  const onDeleteDocument = async (doc: string) => {
    if (doc === "recto") {
        setRectoFile(null);
    } else if (doc === "verso") {
        setVersoFile(null);
    } else {
        setErrorMsg('Une erreur est survenue')
    }
  }

  const document = PROPOSITION_DOC_TYPES.find(el => el.code === docType);

  return (
    <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
        <div className='modale open'>
            <div className="modale--content">
                <div className="modale--content--template">
                    <div className= "modale--main-width-entreprise shadow-bleu pb-lg bg-glace" >
                        <form className="p-x-lg p-y-lg">
                            <p className='card-title bleu'>{document?.label }</p>
                            <p className='text mb-md'>Veuillez télécharger votre document en recto et verso puis cliquez sur <strong>"Confirmer"</strong> pour les télécharger ou cliquez sur <strong>"Annuler"</strong> pour revenir à tout moment à la page principale. </p>

                            <div>
                              { errorFileTypeMsg && <MgpMessage type="danger" message={ERROR_MESSAGES.fileTypeMsg} hasCloseBtn={false}/> }
                              { errorFileSizeMsg && <MgpMessage type="danger" message={ERROR_MESSAGES.fileSizeMsg} hasCloseBtn={false}/> }
                              { errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/> }
                              { uploadError && <p className="bg-fushia blanc p-md m-y-md">
                                {uploadError.split('\n').map((line, index) => (
                                <span key={index} style={{lineHeight: "18px"}}>
                                    {line}
                                <br />
                                </span>
                                ))}
                                </p>
                              }
                            </div> 

                            <div className="form-row jc-space-between">
                              <div className="form-group mw-45">
                                {
                                  !rectoFile ? <p className='fw-medium mb-sm fz-lg'>Veuillez télécharger le recto :</p> : <p className='fw-medium mb-sm fz-lg'>Le recto</p>
                                }
                                {
                                  rectoFile ?
                                    <div className='m-y-xs'> 
                                        <ListOfFileUploaded 
                                            fileName={`${document ? document.code : "document"}-recto`}
                                            onDownloadDocument={() => onDownLoadDocument(rectoFile)}
                                            onDeleteDocument={() => onDeleteDocument('recto')}
                                        />
                                    </div> :
                                    <MgpInputFileUpload
                                      id="recto"
                                      onChange={(e) => handleFileChange(e, 'RECTO')}
                                      register={register} 
                                      errors={errors}
                                      onClick={(e)=> e.currentTarget.value = ''}
                                      label="RECTO"
                                    />
                                }   
                              </div>
                                
                              <div className='form-group mw-45'>
                                  { !versoFile ? <p className='fw-medium mb-sm fz-lg'>Veuillez télécharger le verso :</p> : <p className='fw-medium mb-sm fz-lg'>Le verso</p>}
                                    
                                  { !versoFile ?
                                      <MgpInputFileUpload
                                        id="verso"
                                        onChange={(e) => handleFileChange(e, 'VERSO')}
                                        register={register} 
                                        errors={errors}
                                        onClick={(e)=> e.currentTarget.value = ''}
                                        label="VERSO"
                                      /> :
                                      <div className='m-y-xs'> 
                                        <ListOfFileUploaded 
                                            fileName={`${document ? document.code : "document"}-verso`}
                                            onDownloadDocument={() => onDownLoadDocument(versoFile)}
                                            onDeleteDocument={() => onDeleteDocument('verso')}
                                        /> 
                                      </div>
                                  }         
                              </div>
                                 
                            </div>
                            {
                              handleSwitchUploadFromPhone &&  <button className='text mt-md clickableEl' onClick={() => handleSwitchUploadFromPhone()}><span className='link'>Téléchargez votre document depuis votre smartphone</span></button>
                            }

                            <div className="mt-lg ta-center buttons-bloc">
                                <button className='cta-inline-bleu m-x-lg' onClick={onCloseModal}>Annuler</button>   
                                {rectoFile && versoFile ? <button className='cta-bleu m-x-lg' onClick={onConfirmUploadAction}>Confirmer</button> : <button className='cta-bleu m-x-lg disable' style={{backgroundColor : "#0000004d", cursor: "not-allowed"}}>Confirmer</button>}
                            </div>  
                        </form>

                        { openPreviewFile && file && <UploadFilePreviewModal file={file} onUploadAction={onConfirmAction} isOpen={openPreviewFile} onCloseModal={handleClosePreviewModal} showButton={showUploadButton}/>} 
                        { loading && <LoaderModal hasMessage={true} message='Vos fichiers sont en train de fusionner et uploader'/> }
                     
                    </div>
                </div>
            </div>
        </div>
    </Modal>
  
  )
}
